/** Shared events so Header hamburger can open RestaurantDashboardLayout drawer. */

export const RESTAURANT_NAV_OPEN = 'jr-restaurant-nav-open';
export const RESTAURANT_NAV_CLOSE = 'jr-restaurant-nav-close';
export const RESTAURANT_NAV_TOGGLE = 'jr-restaurant-nav-toggle';
export const RESTAURANT_SIDEBAR_COLLAPSE_TOGGLE = 'jr-restaurant-sidebar-collapse-toggle';
export const BUSINESS_CONTEXT_CHANGED = 'jr-business-context-changed';

export function openRestaurantNav() {
  window.dispatchEvent(new CustomEvent(RESTAURANT_NAV_OPEN));
}

export function closeRestaurantNav() {
  window.dispatchEvent(new CustomEvent(RESTAURANT_NAV_CLOSE));
}

export function toggleRestaurantNav() {
  window.dispatchEvent(new CustomEvent(RESTAURANT_NAV_TOGGLE));
}

export function toggleRestaurantSidebarCollapse() {
  window.dispatchEvent(new CustomEvent(RESTAURANT_SIDEBAR_COLLAPSE_TOGGLE));
}

export function notifyBusinessContextChanged() {
  window.dispatchEvent(new CustomEvent(BUSINESS_CONTEXT_CHANGED));
}
